import { render, staticRenderFns } from "./ImageTable.vue?vue&type=template&id=647b12c2&scoped=true&"
import script from "./ImageTable.vue?vue&type=script&lang=js&"
export * from "./ImageTable.vue?vue&type=script&lang=js&"
import style0 from "./ImageTable.vue?vue&type=style&index=0&id=647b12c2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647b12c2",
  null
  
)

export default component.exports